import React, { Component } from 'react';
import classes from './ModuleAttendanceTab.module.css';
import ShowLoader from '../../../../hoc/ShowLoader/ShowLoader';
import Tabs from '../../../UI/HorizontalTabs/HorizontalTabs';
import * as actionCreators from '../../../../store/actions/index';
import { connect } from "react-redux";
import StudentAttendance from '../../../ReportsPageTabs/StudentAttendance';
import InstructorAttendance from '../../../ReportsPageTabs/InstructorAttendance';


class ModuleAttendanceTab extends Component {
    state = {
        tabs: [
            {
                id: 1,
                label: 'CLASS'
            },
            {
                id: 2,
                label: 'INSTRUCTOR'
            }
        ],
        currentTabId: 1,
        loadingData: false,
        viewAll: this.props.viewAll,
    }
    componentDidMount() {
        this.props.setupProgramDetailsTopbar(true, true, true, true);
    }

    onTabClick = (id) => {
        switch (id) {
            case 1: // Overall Performance Tab
                if (!this.state.loadingData) {
                    this.setState({ currentTabId: id });
                } else {
                    this.setState({ currentTabId: id });
                }
                break;
            case 2: // Attendance Tab
                if (!this.state.loadingData) {
                    this.setState({ currentTabId: id });
                } else {
                    this.setState({ currentTabId: id });
                }
                break;
            default:
                if (!this.state.loadingData) {
                    this.setState({ currentTabId: 1, loadingData: true });
                } else {
                    this.setState({ currentTabId: 1 });
                }
                break;
        }
    }

    CloseModal = () => {
        this.props.onClose(false);
    }

    onShowHideSidebar = (val) => {
        this.setState({ viewAll: !val })
        this.props.handleShowHide(val);

    }

    render() {
        let tabPos = 0;
        for (let item in this.state.tabs) {
            if (this.state.tabs[item].id === this.state.currentTabId) {
                tabPos = item;
            }
        }

        let renderResults = '';

        switch (parseInt(tabPos, 10)) {
            case 0:
                if (this.state.loadingData) {
                    renderResults =
                        <div className={classes.LoaderContainer}>
                            <ShowLoader isLoading={this.state.loadingData} />
                        </div>
                } else {
                    renderResults = <StudentAttendance
                        show={this.onShowHideSidebar}
                        isProgramManager={this.props.isProgramManager}
                        handleShowHide={this.handleSideBar}
                        batchCode={this.props.batchCode}
                        moduleName={this.props.moduleName}

                        onFailureDialogShow={this.props.onFailureDialogShow}
                        redirectToUnauthorized={this.props.redirectToUnauthorized}
                        showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                        redirectToNotFound={this.props.redirectToNotFound}
                        redirectToServerError={this.props.redirectToServerError} />
                }
                break;
            case 1:
                if (this.state.loadingData) {
                    renderResults =
                        <div className={classes.LoaderContainer}>
                            <ShowLoader isLoading={this.state.loadingData} />
                        </div>
                } else {
                    renderResults = <InstructorAttendance
                        isProgramManager={this.props.isProgramManager}
                        handleShowHide={this.handleSideBar}
                        batchCode={this.props.batchCode}
                        moduleName={this.props.moduleName}

                        onFailureDialogShow={this.props.onFailureDialogShow}
                        redirectToUnauthorized={this.props.redirectToUnauthorized}
                        showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                        redirectToNotFound={this.props.redirectToNotFound}
                        redirectToServerError={this.props.redirectToServerError} />
                }
                break;

            default:
                if (this.state.loadingData) {
                    renderResults =
                        <div className={classes.LoaderContainer}>
                            <ShowLoader isLoading={this.state.loadingData} />
                        </div>
                } else {
                    renderResults = <StudentAttendance show={this.onShowHideSidebar} isProgramManager={this.props.isProgramManager} />
                }
        }

        return (
            <div>

                {!this.state.viewAll && <div className={classes.Tabs}>
                    <Tabs
                        tabList={this.state.tabs}
                        onTabClick={this.onTabClick}
                        currentTabId={this.state.currentTabId}
                    />
                </div>}

                <div className={classes.TabData}>
                    {
                        this.state.showError
                            ? <p>Data not available.</p>
                            : renderResults
                    }
                </div>
            </div>

        );
    }
}

const mapStateToProps = state => {
    return {
        activeProgramBatchCode: state.activeProgramBatchCode,
        activeModuleName: state.activeModuleName,
        activeModuleId: state.activeModuleId,

        showSuccessDialog: state.showSuccessDialog,
        successDialogMessage: state.successDialogMessage,
        successDialogButtonLabel: state.successDialogButtonLabel,
        showFailureDialog: state.showFailureDialog,
        failureDialogMessage: state.failureDialogMessage,
        failureDialogButtonLabel: state.failureDialogButtonLabel,
        somethingWentWrong: state.somethingWentWrong,
        notFound: state.notFound,
        unauthorized: state.unauthorized,
    }
}

const mapDisptachToProps = dispatch => {
    return {
        setTopbarTheme: () => dispatch(actionCreators.setTopbarTheme('Light')),

        setupProgramDetailsTopbar: (showTopbar, showProgramProgress, showModuleProgress, hideTopBar) => dispatch(actionCreators.setupProgramDetailsTopbar(showTopbar, showProgramProgress, showModuleProgress, hideTopBar)),

        onFailureDialogShow: (msg, btnLabel) => dispatch(actionCreators.onFailureDialogShow(msg, btnLabel)),
        onFailureDialogHide: () => dispatch(actionCreators.onFailureDialogHide()),
        onSuccessDialogShow: (msg, btnLabel) => dispatch(actionCreators.onSuccessDialogShow(msg, btnLabel)),
        onSuccessDialogHide: () => dispatch(actionCreators.onSuccessDialogHide()),

        redirectToUnauthorized: () => dispatch(actionCreators.redirectToUnauthorized()),
        redirectToNotFound: () => dispatch(actionCreators.redirectToNotFound()),
        redirectToServerError: () => dispatch(actionCreators.redirectToServerError()),
        showSessionExpiredDialog: (show) => dispatch(actionCreators.showSessionExpiredDialog(show))

    }
}

export default connect(mapStateToProps, mapDisptachToProps)(ModuleAttendanceTab);